"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIos = void 0;
const isIos = () => {
    if (typeof window === `undefined` || typeof navigator === `undefined`)
        return false;
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
};
exports.isIos = isIos;
